import routeType from '@/router/routeType'
import paramType from '@/router/paramType'
import {
    ROLE_ADMIN,
    ROLE_RESTAURANT,
    ROLE_COMPANY,
    ROLE_EXTRA_BILLING_ACCESS,
} from '@/enum/roles'

export default {
    computed: {
        menu() {
            return [
                {
                    title: 'menu.orders',
                    icon: 'voucher-bag',
                    route: { name: routeType.ORDER_LIST },
                },
                {
                    title: 'menu.canteens',
                    icon: 'group-orders',
                    roles: [ROLE_ADMIN],
                    children: [
                        {
                            title: 'labels.go_schedule.menu_all',
                            fallback: 'All group orders',
                            route: { name: routeType.CANTEEN_LIST },
                        },
                        {
                            title: 'labels.go_schedule.menu_needs_restaurants',
                            fallback: 'Needs restaurants',
                            route: {
                                name: routeType.CANTEEN_NEEDS_RESTAURANTS,
                            },
                        },
                    ],
                },
                {
                    title: 'menu.users',
                    icon: 'groups',
                    route: { name: routeType.USER_LIST },
                },
                {
                    title: 'menu.companies',
                    icon: 'office-building',
                    route: { name: routeType.COMPANY_LIST },
                },
                {
                    title: 'menu.company_details',
                    icon: 'pencil-edit',
                    route: { name: routeType.COMPANY_SELF_EDIT },
                },
                {
                    title: 'menu.company_allowances',
                    icon: 'meal-allowance',
                    roles: [ROLE_COMPANY],
                    route: {
                        name: routeType.COMPANY_ALLOWANCE_LIST,
                        params: {
                            companyId: this.companyId,
                        },
                    },
                },
                {
                    title: 'menu.company_addresses',
                    icon: 'location-pin',
                    roles: [ROLE_COMPANY],
                    route: {
                        name: routeType.COMPANY_ADDRESS_LIST,
                        params: {
                            companyId: this.companyId,
                        },
                    },
                },
                {
                    title: 'menu.company_employees',
                    icon: 'employees',
                    roles: [ROLE_COMPANY],
                    route: {
                        name: routeType.COMPANY_EMPLOYEES,
                        params: {
                            companyId: this.companyId,
                        },
                    },
                },
                {
                    title: 'menu.teams',
                    icon: 'groups',
                    roles: [ROLE_COMPANY],
                    route: {
                        name: routeType.COMPANY_TEAMS_LIST,
                        params: {
                            companyId: this.companyId,
                        },
                    },
                },
                {
                    title: 'menu.canteen_calendar',
                    icon: 'calendar',
                    roles: [ROLE_COMPANY],
                    route: {
                        name: routeType.COMPANY_CANTEEN_CALENDAR,
                    },
                },
                {
                    title: 'menu.restaurants',
                    icon: 'fork-spoon',
                    route: { name: routeType.RESTAURANT_LIST },
                    roles: [ROLE_ADMIN],
                },
                {
                    title: 'menu.menu',
                    icon: 'fork-spoon',
                    route: {
                        name: routeType.RESTAURANT_EDIT,
                        params: {
                            id: this?.restaurant?.id,
                            page: paramType.RESTAURANT_MENU,
                        },
                    },
                    roles: [ROLE_RESTAURANT],
                },
                {
                    title: 'menu.business_hours',
                    icon: 'clock',
                    route: {
                        name: routeType.RESTAURANT_EDIT,
                        params: {
                            id: this?.restaurant?.id,
                            page: paramType.RESTAURANT_BUSINESS_HOURS,
                        },
                    },
                    roles: [ROLE_RESTAURANT],
                },
                {
                    title: 'menu.brands',
                    icon: 'storefront',
                    route: { name: routeType.BRAND_LIST },
                    roles: [ROLE_ADMIN],
                },
                {
                    title: 'menu.promotions',
                    icon: 'vouchers',
                    roles: [ROLE_ADMIN],
                    children: [
                        {
                            title: 'menu.discounts',
                            route: { name: routeType.PROMOTION_LIST },
                        },
                        {
                            title: 'menu.coupons',
                            route: { name: routeType.COUPON_LIST },
                        },
                        {
                            title: 'menu.promo_banners',
                            route: { name: routeType.PROMO_BANNERS_LIST },
                        },
                    ],
                },
                {
                    title: 'menu.invoices',
                    icon: 'financials',
                    roles: [ROLE_ADMIN],
                    route: { name: routeType.INVOICES_DASHBOARD },
                },
                {
                    title: 'menu.custom_export',
                    icon: 'download',
                    roles: [ROLE_ADMIN],
                    custom_export_edit_required: true,
                    children: [
                        {
                            title: 'menu.custom_export_category',
                            icon: 'grading',
                            route: {
                                name: routeType.CUSTOM_EXPORT_CATEGORY_LIST,
                            },
                        },
                        {
                            title: 'menu.custom_export_edit',
                            icon: 'grading',
                            route: { name: routeType.CUSTOM_EXPORT_LIST },
                        },
                        {
                            title: 'menu.custom_export',
                            icon: 'grading',
                            route: { name: routeType.CUSTOM_EXPORT_SHOW },
                        },
                        {
                            title: 'menu.custom_update',
                            icon: 'grading',
                            route: { name: routeType.CUSTOM_UPDATE_SHOW },
                        },
                    ],
                },
                {
                    title: 'menu.custom_export',
                    icon: 'download',
                    roles: [ROLE_ADMIN],
                    custom_export_edit_required: false,
                    children: [
                        {
                            title: 'menu.custom_export_edit',
                            icon: 'grading',
                            route: { name: routeType.CUSTOM_EXPORT_LIST },
                        },
                        {
                            title: 'menu.custom_export',
                            icon: 'grading',
                            route: { name: routeType.CUSTOM_EXPORT_SHOW },
                        },
                        {
                            title: 'menu.custom_update',
                            icon: 'grading',
                            route: { name: routeType.CUSTOM_UPDATE_SHOW },
                        },
                    ],
                },
                {
                    title: 'menu.invoices',
                    icon: 'financials',
                    roles: [ROLE_RESTAURANT, ROLE_EXTRA_BILLING_ACCESS],
                    route: { name: routeType.INVOICES_DASHBOARD },
                },
                {
                    title: 'menu.invoices',
                    icon: 'financials',
                    roles: [ROLE_COMPANY, ROLE_EXTRA_BILLING_ACCESS],
                    route: {
                        name: routeType.INVOICES_DASHBOARD,
                        params: {
                            companyId: this.companyId,
                        },
                    },
                },
                {
                    title: 'menu.others',
                    icon: 'ellipsis',
                    roles: [ROLE_ADMIN],
                    children: [
                        {
                            title: 'menu.deliveries',
                            route: { name: routeType.DELIVERY_LIST },
                        },
                        {
                            title: 'menu.todos',
                            route: { name: routeType.TODO_LIST },
                        },
                        {
                            title: 'menu.tag_group',
                            route: { name: routeType.TAG_GROUP_LIST },
                        },
                        {
                            title: 'menu.tag',
                            route: { name: routeType.TAG_LIST },
                        },
                        {
                            title: 'menu.residential_canteens',
                            route: { name: routeType.RESIDENTIAL_CANTEENS },
                        },
                        {
                            title: 'menu.residential_canteen_relations',
                            route: {
                                name: routeType.RESIDENTIAL_CANTEEN_RELATIONS,
                            },
                        },
                        {
                            title: 'menu.residential_canteen_addresses',
                            route: {
                                name: routeType.RESIDENTIAL_CANTEEN_ADDRESSES,
                            },
                        },
                    ],
                },
                {
                    title: 'menu.registration_codes',
                    icon: 'clipboard',
                    route: {
                        name: routeType.REGISTRATION_CODES_LIST,
                    },
                },
                {
                    title: 'menu.tablets.main',
                    icon: 'tablet',
                    roles: [ROLE_ADMIN],
                    children: [
                        {
                            title: 'menu.tablets.tablets',
                            route: { name: routeType.TABLETS_CONFIG },
                        },
                        {
                            title: 'menu.tablets.auto_login',
                            route: { name: routeType.TABLETS_AUTO_LOGIN },
                        },
                    ],
                },
                {
                    title: 'menu.settings',
                    icon: 'gear',
                    roles: [ROLE_ADMIN],
                    children: [
                        {
                            title: 'menu.settings',
                            icon: 'settings',
                            route: { name: routeType.SETTINGS },
                        },
                        {
                            title: 'menu.translations',
                            route: { name: routeType.TRANSLATION_LIST },
                        },
                        {
                            title: 'menu.restaurant_highlights',
                            icon: 'restaurant',
                            route: { name: routeType.RESTAURANT_HIGHLIGHTS },
                        },
                        {
                            title: 'settings.eod_spread_page_title',
                            route: { name: routeType.EOD_SPREAD_SETTING },
                        },
                        {
                            title: 'menu.audit',
                            route: { name: routeType.AUDIT_LOG_LIST },
                        },
                        {
                            title: 'menu.push_notifications',
                            route: { name: routeType.PUSH_NOTIFICATIONS },
                        },
                        {
                            title: 'menu.impersonate',
                            route: { name: routeType.IMPERSONATE },
                        },
                    ],
                },
            ]
        },
    },
}
